import React from 'react';

import { StyledKnob, StyledLabel, StyledNativeInput, StyledTrack } from './Switch.styles';
import { TSwitchProps } from './Switch.types';

const Switch = ({ checked, onChange, label, disabled, className }: TSwitchProps) => (
  <StyledLabel className={className} disabled={disabled}>
    <StyledNativeInput
      type="checkbox"
      role="switch"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <StyledTrack checked={checked}>
      <StyledKnob checked={checked} />
    </StyledTrack>
    {label}
  </StyledLabel>
);

export default Switch;
